import React from 'react';

export default function SidebarOrderFilter() {
	return <div>SidebarOrderFilter</div>;
}
